import { unlinkWorkoutItem } from "api-client";
import { useState } from "react";

import { useAuthenticatedNavigationContext } from "src/layout/AuthenticatedNavigationContext";

import { useWorkoutEditStore } from "./WorkoutEditContext";

interface UseUnlinkWorkoutItemReturn {
  unlink: (itemId: string) => Promise<void>;
  isLoading: boolean;
}

export function useUnlinkWorkoutItem(): UseUnlinkWorkoutItemReturn {
  const workoutEditStore = useWorkoutEditStore();
  const { startSaving } = useAuthenticatedNavigationContext();
  const [isLoading, setIsLoading] = useState(false);

  async function unlink(itemId: string) {
    setIsLoading(true);
    const stop = startSaving();

    try {
      const response = await unlinkWorkoutItem({
        path: { workoutId: workoutEditStore.workout.id },
        body: { itemId },
      });

      const data = response.data.data;
      workoutEditStore.applyWorkoutItemChanges(data.operations);

      stop();
    } catch {
      stop("error");
    } finally {
      setIsLoading(false);
    }
  }

  return { unlink, isLoading };
}
